import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Chip, FangChipGroupConfig} from './fang-chip-group.model';
import {sortBy} from '../../core/utils/fang-comp-lib.utils';

@Component({
	selector: 'fang-chip-group',
	styleUrls: ['./fang-chip-group.component.scss'],
	templateUrl: './fang-chip-group.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class FangChipGroupComponent implements OnChanges {
	@HostBinding('style.cursor') cursor;

	@Input() public data: any[];
	@Input() public config: FangChipGroupConfig;

	@Output() public dataChange = new EventEmitter<any[]>();
	@Output() public chipGroupDataChange = new EventEmitter<Chip[]>();

	public chipGroupData: Chip[];

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['data']) {
			this.cursor = this.config.interaction === 'select' ? 'pointer' : 'default';
			this.chipGroupData = this.data.reduce((acc, data, index) => {

				let selected: boolean;

				if (this.config.interaction !== 'select') {
					selected = true;
				} else {
					selected = this.chipGroupData && this.chipGroupData[index] && this.chipGroupData[index].selected;
				}

				acc.push({
					displayValue: this.config.propertyAccessKey ? data[this.config.propertyAccessKey] : data,
					selected
				});
				return acc;
			}, []);

			this.chipGroupData = this.sortData(this.chipGroupData);

			this.chipGroupDataChange.emit(this.chipGroupData);
		}
	}

	public removeChip(event: MouseEvent, chip: any): void {
		event.stopPropagation();

		this.chipGroupData = this.chipGroupData.filter(chipData => chipData.displayValue !== chip.displayValue);
		this.chipGroupData = this.sortData(this.chipGroupData);

		const chipToRemove: any = this.data.filter(data =>
			this.config.propertyAccessKey
				? data[this.config.propertyAccessKey] === chip.displayValue
				: data === chip.displayValue
		)[0];

		this.dataChange.emit(chipToRemove);
		this.chipGroupDataChange.emit(this.chipGroupData);
	}

	public toggleChipSelection(chipIndex: number): void {
		this.chipGroupData[chipIndex].selected = !this.chipGroupData[chipIndex].selected;
	}

	private sortData(data: Chip[]): Chip[] {
		return sortBy(data, ['displayValue']);
	}

}
